import React from 'react';
import { Collapse, Typography } from 'antd';
import '../styles/FAQs.css';

const { Title } = Typography;
const { Panel } = Collapse;

const faqs = [
  {
    question: 'How do I register an account?',
    answer: 'You can register by clicking the Sign Up button at the top right corner and filling in all the required information as instructed.'
  },
  {
    question: 'What should I do if I forget my password?',
    answer: 'Click the "Forgot password" link on the login page and follow the instructions to reset your password.'
  },
  {
    question: 'How can I purchase a course?',
    answer: 'After logging in, select the course you want to buy and click the "Buy Now" button. Follow the payment instructions to complete your purchase.'
  },
  {
    question: 'Can I study on my mobile phone?',
    answer: 'You can access the website on your mobile phone or tablet to study anytime, anywhere.'
  },
  {
    question: 'Will I receive a certificate after completing a course?',
    answer: 'After completing all lessons and tests, you will receive an electronic certificate.'
  }
];

const FAQs = () => {
  return (
    <div className="faqs-container">
      <Title level={2} className="faqs-title">Frequently Asked Questions (FAQs)</Title>
      <Collapse accordion className="faqs-collapse">
        {faqs.map((faq, idx) => (
          <Panel header={faq.question} key={idx} className="faqs-panel">
            <p>{faq.answer}</p>
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default FAQs; 